export const stripTags = (tags: Array<string>, html: string): string =>
	html.replace(new RegExp(`</?(${tags.join('|')}).*?/?>`, 'g'), '');
